import { Component, input } from '@angular/core';

// Titre d'ecran souligne d'un filet orne, et sa phrase d'accroche.
@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.html',
})
export class PageTitle {
  readonly title = input.required<string>();
  readonly lede = input<string | null>(null);
}
